import compose from 'utils/composeEnhancer'
import useHome from './useHome'
import toggleSidebarStore from 'hooks/toggleSidebarStore'

export default compose(
  useHome,
  toggleSidebarStore
)
